
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.417","height":"11.419"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M6.966 4.451a2.59 2.59 0 00-.447-.36 2.664 2.664 0 00-3.32.36L.779 6.873a2.664 2.664 0 003.766 3.77l2-2a.19.19 0 00-.135-.325h-.079a3.2 3.2 0 01-1.218-.236.19.19 0 00-.207.042L3.469 9.563a1.142 1.142 0 01-1.615-1.615l2.43-2.428a1.142 1.142 0 011.614 0 .78.78 0 001.069 0 .754.754 0 000-1.069z"}}),_c('path',{staticClass:"a",attrs:{"d":"M10.637.781a2.664 2.664 0 00-3.768 0l-2 1.994a.191.191 0 00.139.325h.07a3.2 3.2 0 011.216.238.19.19 0 00.207-.042l1.433-1.431A1.142 1.142 0 019.549 3.48L7.764 5.263l-.015.017-.624.62a1.142 1.142 0 01-1.614 0 .78.78 0 00-1.069 0 .759.759 0 000 1.073 2.641 2.641 0 00.761.533c.04.019.08.034.12.051s.082.03.122.046.082.029.122.04l.112.03c.076.019.152.034.23.048a2.649 2.649 0 00.284.027h.145l.114-.013c.042 0 .086-.011.135-.011h.065l.131-.019.061-.011.11-.023h.021a2.664 2.664 0 001.235-.7l2.422-2.422a2.664 2.664 0 00.005-3.768z"}})])
          )
        }
      }
    